import { IntervalUnit, Cycle } from '@wix/ambassador-premium-store/types';
import {
  DoublePurchaseValidationResult,
  DynamicDoublePurchaseValidationResult,
} from '../pages/CheckoutPage/CheckoutPageTypes';
import { PaymentCycle } from '../enums';

export const convertCycleSelectorToPaymentCycle = (
  alternativeCycle: Cycle,
): PaymentCycle => {
  if (alternativeCycle.interval?.unit === IntervalUnit.MONTH) {
    if (alternativeCycle.interval?.count === 1) {
      return PaymentCycle.MONTHLY;
    }
    if (alternativeCycle.interval?.count === 3) {
      return PaymentCycle.QUARTERLY;
    }
  }
  if (alternativeCycle.interval?.unit === IntervalUnit.YEAR) {
    if (alternativeCycle.interval?.count === 1) {
      return PaymentCycle.YEARLY;
    }
    if (alternativeCycle.interval?.count === 2) {
      return PaymentCycle.YEAR2;
    }
    if (alternativeCycle.interval?.count === 3) {
      return PaymentCycle.YEAR3;
    }
  }

  throw new Error(
    `convertCycleSelectorToPaymentCycle: failed to convert input: ${JSON.stringify(
      alternativeCycle,
    )}`,
  );
};

export const convertPaymentCycleToCycle = (cycle: PaymentCycle): Cycle => {
  let count, unit;
  switch (cycle) {
    case PaymentCycle.MONTHLY:
      count = 1;
      unit = IntervalUnit.MONTH;
      break;
    case PaymentCycle.QUARTERLY:
      count = 3;
      unit = IntervalUnit.MONTH;
      break;
    case PaymentCycle.YEARLY:
      count = 1;
      unit = IntervalUnit.YEAR;
      break;
    case PaymentCycle.YEAR3:
      count = 3;
      unit = IntervalUnit.YEAR;
      break;
    case PaymentCycle.YEAR4:
      count = 4;
      unit = IntervalUnit.YEAR;
      break;
    case PaymentCycle.YEAR5:
      count = 5;
      unit = IntervalUnit.YEAR;
      break;
    default:
      count = 2;
      unit = IntervalUnit.YEAR;
  }
  return { interval: { count, unit } };
};

export const convertDoublePurchaseStatusToCode = (
  status: DynamicDoublePurchaseValidationResult,
): DoublePurchaseValidationResult => {
  if (status === DynamicDoublePurchaseValidationResult.SERVER_ERROR) {
    return DoublePurchaseValidationResult.GENERAL_ERROR;
  }
  if (status === DynamicDoublePurchaseValidationResult.DELIVERED) {
    return DoublePurchaseValidationResult.ALREADY_DELIVERED;
  }
  return DoublePurchaseValidationResult.PENDING;
};
